export const CLEANUP_STALE_ENTITIES = "CLEANUP_STALE_ENTITIES";

export interface CleanupStaleEntitiesAction {
  type: typeof CLEANUP_STALE_ENTITIES;
}

export type CleanupAction = CleanupStaleEntitiesAction;
